import { render, staticRenderFns } from "./orderDetailItem.vue?vue&type=template&id=3254c754&scoped=true&"
import script from "./orderDetailItem.vue?vue&type=script&lang=js&"
export * from "./orderDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailItem.vue?vue&type=style&index=0&id=3254c754&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254c754",
  null
  
)

export default component.exports